export default "__VITE_ASSET__CczZ5n5Q__"